import { IconButton } from '@mui/material';
import ArrowCircleLeftIcon from '@mui/icons-material/ChevronLeft';
import { useNavigate, useSearchParams } from 'react-router';
import { useAppDispatch, useAppSelector } from '@reduxStore';
import { setDispatchSnapshot } from '@/Infrastructure/applicationSlice';

import styles from '../DataGrid.Dispatch.module.css';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { emptyRowSet } from '@components/DataGrid/types';

/**
 * Button for returning to whichever page (Board, Research, etc.) the user was on before drilling into legs.
 */
export default function DispatchBackButton() {
	const appDispatch = useAppDispatch();
	const gridApiRef = useGridApiContext();
	const navigate = useNavigate();
	const [, setSearchParams] = useSearchParams();
	const { dispatchPathSnapshot, selectedTerminal } = useAppSelector((state) => state.applicationState);

	const previousNavHandler = () => {
		// Clear any selected rows
		gridApiRef.current.setRowSelectionModel(emptyRowSet);

		if (dispatchPathSnapshot) {
			// Navigate to the full snapshot URL so we return to the originating page
			// (e.g. Research) and not just restore query params on the current path.
			void navigate(dispatchPathSnapshot);
			appDispatch(setDispatchSnapshot());
		} else {
			// Just go back to the default board
			setSearchParams({});
		}
	};

	const tooltip = dispatchPathSnapshot ? 'Back' : `Return to board for terminal: ${String(selectedTerminal?.number)}`;

	return (
		<IconButton
			title={tooltip}
			onClick={previousNavHandler}
			className={styles['icon-btn']}
		>
			<ArrowCircleLeftIcon />
		</IconButton>
	);
}
